import React, {useCallback, useEffect, useState} from 'react';
import _ from 'lodash';

const TitleContext = React.createContext({});

export const useTitle = title=>{
    let {add} = React.useContext(TitleContext);
    useEffect(()=>{
        if (!title)
            return;
        return add(title);
    }, [title, add]);
};

export const TitleProvider = props=>{
    let {children, defaultTitle} = props;
    let [stack, setStack] = useState([]);
    useEffect(()=>{
        let title;
        if (stack.length)
            title = stack[stack.length-1].title;
        else
            title = defaultTitle;
        document.title = title;
    }, [stack, defaultTitle]);
    let add = useCallback(title=>{
        let id = Symbol(title);
        setStack(prev=>[...prev, {id, title}]);
        return ()=>setStack(prev=>prev.filter(t=>t.id!==id));
    }, []);
    return <TitleContext.Provider value={{add}}>
      {children}
    </TitleContext.Provider>;
};

export const withTitle = (title, Comp)=>props=>{
    useTitle(title);
    return <Comp {...props}/>;
};
